import { Environment } from './types'

export function getEnvironment() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT as Environment
}

export function getApiUrl() {
  return process.env.NEXT_PUBLIC_API_URL
}

export function getAuthUrl() {
  return process.env.NEXT_PUBLIC_AUTH_URL
}

export function getPlacementPreviewUrl() {
  return process.env.NEXT_PUBLIC_PLACEMENT_PREVIEW_URL
}

export function getRollbarToken() {
  return process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN
}

export function shouldUseMockServer() {
  return process.env.NEXT_PUBLIC_USE_MOCK_SERVER === 'true'
}
